<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
  @if (data.organizationType === OrganizationType.Business) {
    Erhverv standard adgangsgrupper
  }
  @if (data.organizationType === OrganizationType.HousingAssociation) {
    Boligforening standard adgangsgrupper
  }
  @if (data.organizationType === OrganizationType.Municipality) {
    Kommune standard adgangsgrupper
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  @let standardAccessGroups = (standardAccessGroups$ | async) ?? [];
  <div class="multi-select">
    <div class="multi-select__list multi-select__list--grid">
      @if (standardAccessGroups.length > 0) {
        <div class="multi-select__headers">
          <div class="multi-select__item--name">
            <strong>Navn</strong>
          </div>
          <div class="multi-select__item--discount">
            <strong>Rabat i %</strong>
          </div>
          <div class="multi-select__item--discount">
            <strong>Rabat i kr</strong>
          </div>
          <div class="multi-select__item--carType">
            <strong>Biltype</strong>
          </div>
          <div></div>
          <div></div>
        </div>
      }
      @for (defaultAccessGroup of standardAccessGroups; track defaultAccessGroup) {
        <div
          class="multi-select__item multi-select__item--tall"
          [class.highlight]="defaultAccessGroup.identifier === defaultAccessGroupBeingEdited?.identifier">
          <div class="multi-select__item--name">
            <span>{{ defaultAccessGroup.name }}</span>
          </div>
          <div class="multi-select__item--discount">
            <span>{{ defaultAccessGroup.amountPercentage }}%</span>
          </div>
          <div class="multi-select__item--discount">
            <span>{{ defaultAccessGroup.amountFixed | dkCurrency }}</span>
          </div>
          <div class="multi-select__item--carType">
            <span>{{ defaultAccessGroup.carType | translateAccessGroupCarTypeEnum }}</span>
          </div>
          <button mat-icon-button title="Rediger" type="button" (click)="editDefaultAccessGroupUser(defaultAccessGroup)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
          </button>
          <button
            mat-icon-button
            class="delete"
            title="Fjern"
            type="button"
            (click)="deleteDefaultAccessGroupUser(defaultAccessGroup)"
            [disabled]="defaultAccessGroupBeingEdited === defaultAccessGroup">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
          </button>
        </div>
      }
      <div class="multi-select__input">
        <form class="filter-dropdown" [formGroup]="form">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Navn</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>
          <mat-form-field [matTooltip]="'Tværgående rabat i %'" subscriptSizing="dynamic">
            <mat-label>Tværgående rabat i %</mat-label>
            <mat-select formControlName="percentageDiscountIdentifier" okCustomDropDownArrowDirective>
              @for (discount of percentageDiscounts$ | async; track discount) {
                <mat-option [value]="discount.identifier"> {{ discount.name }} {{ discount.amount }}% </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
          </mat-form-field>
          <mat-form-field [matTooltip]="'Tværgående rabat i kr.'" subscriptSizing="dynamic">
            <mat-label>Tværgående rabat i kr.</mat-label>
            <mat-select formControlName="fixedDiscountIdentifier" okCustomDropDownArrowDirective>
              @for (discount of fixedDiscounts$ | async; track discount) {
                <mat-option [value]="discount.identifier"> {{ discount.name }} {{ discount.amount | dkCurrency }} </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Vælg biltype</mat-label>
            <mat-select formControlName="carType" okCustomDropDownArrowDirective>
              @for (cartype of carTypes | enumToArray | translateAccessGroupCarTypeEnum; track cartype) {
                <mat-option [value]="cartype.index">
                  {{ cartype.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
          </mat-form-field>
          @if (!defaultAccessGroupBeingEdited) {
            <button mat-flat-button color="primary" (click)="createDefaultAccessGroup()" class="add-button" [disabled]="form.invalid">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
            </button>
          }

          @if (defaultAccessGroupBeingEdited) {
            <button mat-flat-button color="primary" (click)="updateDefaultAccessGroup()" class="add-button" [disabled]="form.invalid">
              Gem
            </button>
          }
        </form>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
